import { APP_VERSION } from "./version.js";

import "./firebase-config.js";
import "./auth.js";
import "./router.js";
import { modal } from "./components/modal.js";
import { pwaManager } from "./pwa/PWAManager.js";
import { InAppNotificationService } from "./services/in-app-notification.service.js";
import { NotificationListModal } from "./components/notification-list-modal.js";
import { InAppBrowserGuide } from "./components/common/InAppBrowserGuide.js";
import { SupportFab } from './components/feature/support/SupportFab.js'; // [NEW] Support System

// Initialize In-App Browser Guide (Premium Overlay)
InAppBrowserGuide();

// [DevTools] Console Cleaner for Production
// Mutes console.log/info in production to keep F12 clean (Warnings/Errors only)
// Toggle: localStorage.setItem('debug', 'true') to force logs in production.
try {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname.includes('127.0.0.1');
    const isDebugMode = localStorage.getItem('debug') === 'true';

    if (!isLocal && !isDebugMode) {
        // Build a no-op function
        const noOp = () => { };

        // Save original just in case
        // window._originalConsoleLog = console.log;

        // Mute
        console.log = noOp;
        console.info = noOp;
        console.debug = noOp;

        // Note: console.warn and console.error remain active.
    }
} catch (e) {
    // Ignore error if console modification fails
}

// --- EMERGENCY CACHE BUSTER ---
// Legacy code removed. Version management is now handled by PWA Service Worker.
// ------------------------------
// ------------------------------

// [TRACKING] Capture Marketing Source from URL
// Example: mirinae.com/?source=instagram&campaign=summer_promo
try {
    const urlParams = new URLSearchParams(window.location.search);
    const sourceParam = urlParams.get('source');
    const campaignParam = urlParams.get('campaign');

    // [SEO] Handle Cloud Function Redirects
    // Format: /?redirect=/novel/123&ref=abc
    const redirectPath = urlParams.get('redirect');
    if (redirectPath) {
        console.log(`[SEO] Handling Deep Link: ${redirectPath}`);
        // Remove 'redirect' key, keep 'ref' and others
        urlParams.delete('redirect');
        const remainingParams = urlParams.toString();
        const hashQuery = remainingParams ? `?${remainingParams}` : '';

        // [FIX] Clean URL immediately to prevent 'Sticky Redirect' on Reload
        const cleanPathname = window.location.pathname;
        const newHistoryUrl = cleanPathname + (remainingParams ? `?${remainingParams}` : '');
        window.history.replaceState({}, '', newHistoryUrl);

        // Construct Hash Route: /#/novel/123?ref=abc
        const newUrl = `${window.location.pathname}#${redirectPath}${hashQuery}`;

        // Immediate Redirect
        window.location.replace(newUrl);
        // Stop further execution to prevent race conditions
        throw new Error("Redirecting...");
    }

    if (sourceParam) {
        // ... (Existing Marketing Logic)
        sessionStorage.setItem('marketing_source', sourceParam);
        if (campaignParam) sessionStorage.setItem('marketing_campaign', campaignParam);

        console.log(`[Marketing] Source captured: ${sourceParam}`);

        // Optional: Clean URL to hide tracking params (UX)
        const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.hash;
        window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
    }
} catch (e) {
    if (e.message !== "Redirecting...") {
        console.warn("[Marketing/SEO] URL parsing failed or redirecting", e);
    }
}

window.Modal = modal;


// Ensure router handles initial URL
if (window.router) {
    window.router.loadInitialRoute();
}

// Display Version
const versionDisplay = document.getElementById('app-version-display');
if (versionDisplay) {
    versionDisplay.textContent = APP_VERSION;
    // Hidden Feature: Click version to force update check
    versionDisplay.style.cursor = 'pointer';
    versionDisplay.onclick = () => {
        if (confirm("업데이트를 확인하시겠습니까?")) {
            pwaManager.checkForUpdates();
        }
    };
}

// console.log(`Mirinae Platform Loaded ${APP_VERSION} (Modular PWA)`);

// Initialize PWA Manager
// Initialize PWA Manager
pwaManager.init();


// Smart Copy Protection: Prevent Context Menu
// Smart Copy Protection: Prevent Context Menu
document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
}, { passive: false });

// Initialize UI Layout
// FIX: Do NOT create a new Layout here. Router already creates it.
// We must wait for Router to be initialized.
if (window.router) {
    window.app.layout = window.router.layout;
    window.app.drawer = window.app.layout.drawer;
} else {
    // Fallback if router is not ready (should not happen with imports)
    console.error("Router not ready during index.js init");
}

// [NEW] Initialize Support System
import { initSupportSystem } from './features/support/init.js';
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSupportSystem);
} else {
    initSupportSystem();
}


// --- Global Notification Logic ---
// We hook into the router or auth state to initialize this.
// Ideally, auth.js should fire an event, or we poll. 
// Since window.user is set by auth.js, we can check it.
// However, auth.js is a module. Let's add a simple continuous check or leverage the fact that UI rebuilds happen.

// Better: Expose a global init function or hook onto `window.auth` which is exposed.
// Let's use a simple poller or wait for DOMContentLoaded + window.user presence check 
// But window.user takes time to populate.
// Let's modify the auth listener inside auth.js? No, intrusive.
// Let's just monitor `window.user` changes roughly or initialize when user interacts.

// Actual Solution: We'll overwrite `window.onAuthStateChanged` or similar if it existed.
// But we can just use `getAuth().onAuthStateChanged` here if we import it.
import { getAuth } from "firebase/auth";
import { app } from "./firebase-config.js";
import { Header } from "./components/layout/Header.js"; // Import Header Component

const auth = getAuth(app);
let unsubscribeNotif = null;

auth.onAuthStateChanged((user) => {
    window.user = user;

    // 1. Refresh System Drawer (if exists)
    if (window.app && window.app.drawer) {
        window.app.drawer.refreshMenu();
        // Also ensure Profile Card updates
        if (window.app.drawer.updateHeader) window.app.drawer.updateHeader();
        if (window.app.drawer.updateFooter) window.app.drawer.updateFooter();
    }

    // 2. Refresh Main Header (Profile Avatar)
    if (window.app && window.app.layout) {
        if (window.app.layout.header && window.app.layout.header.updateHeader) {
            window.app.layout.header.updateHeader();
            // CRITICAL: Re-apply layout visibility rules (e.g., Hide Search on Home)
            // because updateHeader() recreates buttons, resetting their style.
            if (window.app.layout.handleRouteChanged) {
                // Use setTimeout to allow DOM reflow if needed, though sync should work.
                // Sync is better to prevent flash.
                window.app.layout.handleRouteChanged();
            }
        }
    }

    // 3. Initialize Notification Service (Real Push)
    // We import dynamically to avoid bundle bloat if unused, but it's small enough.
    // Ideally we want to listen for foreground messages.
    import("./services/push-notification.service.js").then(({ PushNotificationService }) => {
        PushNotificationService.listen();

        // Optional: Silent token refresh or VAPID check could go here.
        // For now, we rely on the manual toggle in SettingsPage to register the token initially.
    });

    // 3. Notification Logic (Enabled)
    if (user) {
        if (unsubscribeNotif) unsubscribeNotif();
        // Subscribe to Unread Count
        unsubscribeNotif = InAppNotificationService.subscribeUnreadCount(user.uid, (count) => {
            // Update Header Badge
            if (window.app && window.app.layout && window.app.layout.header) {
                if (window.app.layout.header.setNotificationBadge) {
                    window.app.layout.header.setNotificationBadge(count > 0);
                }
            }
            // Fallback for direct DOM manipulation (if header isn't fully reactive)
            const curBadge = document.getElementById('notification-badge'); // Legacy ID check
            if (curBadge) {
                if (count > 0) curBadge.classList.remove('hidden');
                else curBadge.classList.add('hidden');
            }
        });
    } else {
        if (unsubscribeNotif) unsubscribeNotif();
        // Clear badge on logout
        if (window.app && window.app.layout && window.app.layout.header && window.app.layout.header.setNotificationBadge) {
            window.app.layout.header.setNotificationBadge(false);
        }
    }
});

// 4. [FIX v1.00001] Router Safety Kicker
// If we are at a non-root path but router has no hash, it means the Redirect Script failed or wasn't present.
// We force a redirect to capture the state.
setTimeout(() => {
    // Check if we are "stuck" on Splash Screen effectively
    const path = window.location.pathname;
    const hash = window.location.hash;

    if (path !== '/' && !path.startsWith('/login') && !path.startsWith('/__/') && !hash) {
        console.warn("[Safety] Path detected without hash. Redirecting...");
        // Manual Redirect
        window.location.replace('/#' + path + window.location.search);
    }
}, 2000);
